
import userReducer from './userReducersHelper';
import questionReducer from './questionReducersHelper';
import receiptReducer from './receiptReducersHelper';
import packageReducer from './packageReducersHelper';
import recordReducer from './recordReducersHelper';
import testReportReducer from './testReportReducer';
import examinationReducer from './examinationReducersHelper';
import announcementReducer from './announcementReducersHelper';

const allReducers = {
    user: userReducer,
    question: questionReducer,
    receipt: receiptReducer,
    package: packageReducer,
    record: recordReducer,
    testReport: testReportReducer,
    examination: examinationReducer,
    announcement: announcementReducer,
};

export default allReducers;
